var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9.5a7.5 7.5 0 01-12.05 5.963l-5.243 5.244a1 1 0 01-1.414-1.414l5.244-5.244A7.5 7.5 0 1122 9.5zm-2 0a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z",
    fill: "#9CA6AD"
  })));
};

export default SvgSearch;